import React, { FC, useEffect, useState } from 'react';
import { SecureContext } from './hooks/security'
import { HashRouter as Router } from 'react-router-dom';
import './scss/app.scss';
import { createTheme, Theme, ThemeProvider } from '@mui/material/styles';
import { getColors } from './components/Shared/Functions';
import { SnackbarProvider } from 'notistack';
import Routing from './components/Shared/Routing';

const App: FC = (props) => {

    const [theme, setTheme] = useState<Theme | null>(null);

    useEffect(() => {
        getColors()
            .then((x:any) => {
                setTheme(createTheme({
                    palette: {
                      primary: {
                        main: x?.primary,
                      },
                      secondary: {
                        main: x?.secondary,
                      },
                    }
                  }));
            })
    }, [])

    // Add role="status" to notistack snackbar wrappers for accessibility (WCAG 4.1.2, 2.1.1)
    // Also fix duplicate notistack-snackbar IDs and aria-describedby references
    useEffect(() => {
        const observer = new MutationObserver(() => {
            document.querySelectorAll('.SnackbarItem-wrappedRoot:not([role])').forEach(el => {
                el.setAttribute('role', 'status');
            });
            const snackbarMsgs = document.querySelectorAll('[id^="notistack-snackbar"]');
            snackbarMsgs.forEach((el, i) => {
                const newId = i === 0 ? 'notistack-snackbar' : `notistack-snackbar-${i}`;
                el.id = newId;
                // Fix aria-describedby on the parent SnackbarContent-root to match the new ID
                const contentRoot = el.closest('.SnackbarContent-root');
                if (contentRoot) {
                    contentRoot.setAttribute('aria-describedby', newId);
                }
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, [])

    return (
        <>
            {theme === null ? null :
                <ThemeProvider theme={theme}>
                    <SnackbarProvider
                        maxSnack={5}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}>
                        <SecureContext>
                            <Router>
                                <Routing />
                            </Router>
                        </SecureContext>
                    </SnackbarProvider>
                </ThemeProvider>
            }
        </>)
}


export { App as default };
